import {Box, Card, Typography} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {getRandomColor} from '@jobseeker/lotus/theme';
import {useMemo} from 'react';
import {
  DefaultJobLogo,
  TopRecrBadge10,
  TopRecrBadge10p,
  TopRecrBadge3,
  TopRecrBadge5,
  TopRecrBadge5p,
  TopStar,
} from '@jobseeker/lotus/assets/icons';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';
import {ImageWithFallback} from '@jobseeker/lotus/components/JobList/V2';
const ConsultantStrip: React.FC<{
  jobInfo?: any;
}> = ({jobInfo}) => {
  const IsLarge = useIsLargeDevice('sm');

  const randomColor = useMemo(
    () => getRandomColor(jobInfo?.id),
    [jobInfo?.companyData]
  );
  const yrs = jobInfo?.recruiter?.firstRecrTime || 0;
  const badge =
    yrs > 10
      ? TopRecrBadge10p
      : yrs == 10
        ? TopRecrBadge10
        : yrs > 5
          ? TopRecrBadge5p
          : yrs == 5
            ? TopRecrBadge5
            : TopRecrBadge3;
  return (
    <Box position="relative">
      <Card
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: '#E6E9F4',
          py: 1.5,
          mt: {xxs: -1.5, md: 0},
          px: {xxs: 1.5, md: 2.5},
          borderRadius: 0,
          borderBottomLeftRadius: {xxs: 0, md: 16},
          borderBottomRightRadius: {xxs: 0, md: 16},
        }}
      >
        <Box display="flex" alignItems={{xxs: 'start', md: 'center'}} gap={1}>
          {(!jobInfo?.showcase?.showcaseImages?.length || true) && (
            <Box
              sx={{
                '.joblist__logo': {
                  borderRadius: 3,
                  overflow: 'hidden',
                  background: jobInfo?.companyData?.companyLogoFilePath
                    ? '#fff'
                    : 'auto',
                  boxShadow: 2,
                  border: '0.6px solid #7E7E7E33',
                },
                height: 50,
              }}
              borderRadius={3}
            >
              {!jobInfo?.confidential &&
              jobInfo?.companyData?.companyLogoFilePath ? (
                <ImageWithFallback
                  className="joblist__logo"
                  src={jobInfo?.companyData?.companyLogoFilePath ?? ''}
                  fallback={''}
                  blurDataURL={jobInfo?.companyData?.companyLogoFilePath || ''}
                  alt={`${jobInfo?.companyData?.companyName?.replace(
                    /\s+/g,
                    ''
                  )}_logo'`}
                  width={'50'}
                  style={{
                    cursor: 'default',
                    borderRadius: 3,
                  }}
                  height={'50'}
                  objectFit="cover"
                  quality={50}
                  placeholder="blur"
                  itemId={jobInfo?.id}
                />
              ) : (
                <Box
                  className="joblist__logo"
                  sx={{
                    background: randomColor,
                    p: 1.5,

                    height: 'min-content',
                    lineHeight: 0,
                  }}
                >
                  <Image
                    src={DefaultJobLogo}
                    alt={'Logo'}
                    width={'25'}
                    height={'25'}
                    objectFit="cover"
                    quality={50}
                  />
                </Box>
              )}
            </Box>
          )}

          <Box>
            <Typography
              fontSize={12}
              fontWeight={{xxs: 400, md: 500}}
              maxWidth={{xxs: '180px', md: 'none'}}
            >
              {`Posted by ${jobInfo?.companyData?.companyName}`}
            </Typography>

            <Box
              display={'flex'}
              alignItems={'center'}
              bgcolor={'#FFF'}
              borderRadius={'10000px'}
              px={1.25}
              py={0.25}
              border="1px solid var(--Colors-Alice-Blue-500, #F3F7FA)"
              mt={0.5}
              width={'fit-content'}
            >
              <Image src={TopStar} height={14} width={14} alt="star" />
              <Typography
                fontSize={11}
                fontWeight={400}
                ml={0.5}
                sx={{opacity: 0.4}}
              >
                Top recruitment agency
              </Typography>
            </Box>
          </Box>
        </Box>
      </Card>

      <Box
        sx={{
          position: 'absolute',
          right: {xxs: 0, md: 16},
          top: '50%',
          transform: {
            xxs:
              (jobInfo?.companyData?.companyName?.length || 0) > 18
                ? 'translateY(-47%)'
                : 'translateY(-43%)',
            md: 'translateY(-41%)',
          },
          width: 90,
          height: {xxs: 130, md: 150},
          zIndex: 2,
        }}
      >
        <Image
          src={badge}
          alt="Top Recruitment Badge"
          width={90}
          height={IsLarge ? 150 : 135}
        />
      </Box>
    </Box>
  );
};
export default ConsultantStrip;
